import React, { FormEvent, useCallback, useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

import Textfield from '@atlaskit/textfield';
import Tooltip from '@atlaskit/tooltip';

import { InputSearchIcon } from '@qality/common-components/src/atoms/InputSearchIcon';
import { useTestCaseFilterContext } from '@qality/common-components/src/test-cycle/TestCaseFilter';
import {
  DEBOUNCE_DELAY_MS,
  FEATURE_FLAG,
  UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE,
} from '@qality/common-config';

export function TestCaseInCycleSearchFilter(): JSX.Element {
  const [searchValue, setSearchValue] = useState('');

  const { setTextSearchFilter } = useTestCaseFilterContext();

  const debouncedTestCaseInCycleSearch = useCallback(
    debounce(setTextSearchFilter, DEBOUNCE_DELAY_MS),
    []
  );

  useEffect(() => {
    debouncedTestCaseInCycleSearch(searchValue);
  }, [searchValue]);

  const handleInputChange = (event: FormEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  return (
    <div>
      <Tooltip
        content={
          !FEATURE_FLAG.isPremium && UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE
        }
        testId='disabled-search-tooltip'
      >
        <Textfield
          isDisabled={!FEATURE_FLAG.isPremium}
          placeholder='Search for test case'
          value={searchValue}
          testId='search-text-field'
          onChange={handleInputChange}
          style={{ height: '29px', width: '329px' }}
          elemBeforeInput={<InputSearchIcon />}
        />
      </Tooltip>
    </div>
  );
}
